import { Instance } from "../Base";

export default abstract class Decorator implements Instance {
  protected _component: Instance;

  constructor(component: Instance) {
    this._component = component;
  }

  get element(): HTMLElement {
    return this._component.element;
  }

  get component(): Instance {
    return this._component;
  }
}
